import { ID } from '../../../types/UtilityTypes'
import { createAction, createAsyncAction } from 'typesafe-actions'
import { FileData } from '../../../responses/files'
import { Comment } from '../../../responses/comments'

// todo refactor using morphic-ts
export type GalleryData = {
    type: 'none',
} | {
    type: 'task' | 'comment',
    objectId: ID,
    tasksId: ID[],
} | {
    type: 'project',
    projectId: ID,
} | {
    type: 'object',
    objectId: ID,
} | {
    type: 'single',
    comment: Comment,
}


export const galleryActions = {
    open: createAction('@GALLERY/OPEN')<GalleryData & { current: FileData | null }>(),
    close: createAction('@GALLERY/CLOSE')(),
    setCurrent: createAction('@GALLERY/SET_CURRENT')<FileData | null>(),
    startDelete: createAction('@GALLERY/START_DELETE')<FileData>(),
    cancelEdit: createAction('@GALLERY/CANCEL_EDIT')(),
    setComments: createAction('@GALLERY/SET_COMMENTS')<Comment[]>(),
    delete: createAsyncAction(
        'GALLERY/DELETE_REQUEST',
        'GALLERY/DELETE_SUCCESS',
        'GALLERY/DELETE_FAILURE',
    )<undefined, undefined, void>(),
}